// ~/composables/useTimeBasedContent.js
export const useTimeBasedContent = () => {
    // Function to get the current date in the desired timezone
    const getCurrentDateInTimezone = (timezone = "America/Indiana/Indianapolis") => {
      const now = new Date();
      const formattedDate = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        year: "numeric",
        month: "numeric",
        day: "numeric"
      }).format(now);
  
      // Split the date into components
      const [month, day, year] = formattedDate.split('/');
      return new Date(`${year}-${month}-${day}`);
    };
  
    // Function to get sale text and visibility based on the date
    const getSaleTextAndVisibility = () => {
      const currentDate = getCurrentDateInTimezone();
      const month = currentDate.getMonth() + 1; // Months are 0-indexed
      const day = currentDate.getDate();
  
      if (month === 11) {
        return { text: "BLACK FRIDAY SALE! 72% OFF + FREE GIFTS", visible: true };
      } else if (month === 12 && day >= 1 && day <= 3) {
        return { text: "CYBER MONDAY SALE! 72% OFF + FREE GIFTS", visible: true };
      } else if (month === 12 && day >= 4) {
        return { text: "Holiday Sale! 72% OFF + FREE GIFTS", visible: true };
      } else if (month === 1) {
        return { text: "NEW YEARS SALE! 72% OFF + FREE GIFTS", visible: true };
      } else {
        return { text: "", visible: false };
      }
    };
  
    return {
      getCurrentDateInTimezone,
      getSaleTextAndVisibility
    };
  };
  